export const getGeoLocation = (locationData) => ({
  type: "GEO_LOCATION_GET",
  payload: locationData
});

export default getGeoLocation;
